import axios from "axios";
import { API_BASE_URL } from "../utils/config";

export const getReportMemberMaintenance = async (payload) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/reports/members?page=${payload.page}&size=${payload.length}`,
    );
    return {
      response: {
        data: response.data,
        status: response.status,
        statusText: response.statusText,
      },
      API_Name: "getReportMemberMaintenance",
    };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};
